import { render } from "./BuilderMobileStepPagination.vue?vue&type=template&id=64b57a15&scoped=true&ts=true&lang=pug"
import script from "./BuilderMobileStepPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderMobileStepPagination.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderMobileStepPagination.vue?vue&type=style&index=0&id=64b57a15&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b57a15"]])

export default __exports__